export default __webpack_public_path__ + "static/media/closeIcon.38954826.svg";